import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { AccountPageWrapper } from "../../Shared/components/PageWrapper/AccountPageWrapper";
import { AccountPageTitle } from "../utils/Page";
import ProfileForm from "./ProfileForm";
const Profile = () => {
    return (_jsxs(AccountPageWrapper, Object.assign({ id: "profile-page" }, { children: [_jsx(AccountPageTitle, { title: "Profile" }), _jsx(Stack, Object.assign({ rowGap: 1, justifyContent: "center", alignItems: "center" }, { children: _jsx(ProfileForm, {}) }))] })));
};
export default Profile;
